import {TextStyle} from 'react-native';

export const ColorStyles = {
  black90: {
    color: 'rgba(0, 0, 0, 0.9)',
  } as TextStyle,
  black80: {
    color: 'rgba(0, 0, 0, 0.8)',
  } as TextStyle,
  black70: {
    color: 'rgba(0, 0, 0, 0.7)',
  } as TextStyle,
  black60: {
    color: 'rgba(0, 0, 0, 0.6)',
  } as TextStyle,
  black50: {
    color: 'rgba(0, 0, 0, 0.5)',
  } as TextStyle,
  black40: {
    color: 'rgba(0, 0, 0, 0.4)',
  } as TextStyle,
  black30: {
    color: 'rgba(0, 0, 0, 0.3)',
  } as TextStyle,
  black20: {
    color: 'rgba(0, 0, 0, 0.2)',
  } as TextStyle,
  black10: {
    color: 'rgba(0, 0, 0, 0.1)',
  } as TextStyle,
};
